export default __webpack_public_path__ + "static/media/Short Call.7d976814.svg";